const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';
const API_BASE_URL_AUTH = process.env.REACT_APP_AUTH_URL || 'http://localhost:8000/api';

const DEFAULT_HEADERS = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',
  'countryslug': process.env.REACT_APP_COUNTRY_SLUG || 'bvi',
};

const getHeaders = (authToken = null) => {
  const headers = { ...DEFAULT_HEADERS };
  if (authToken) {
    headers['Authorization'] = `Bearer ${authToken}`;
  }
  return headers;
};

export { API_BASE_URL, API_BASE_URL_AUTH, DEFAULT_HEADERS, getHeaders }; 